import React, { useState } from "react";
import {
  getTokenFromLocalStorage,
  getBUFromLocalStorage,
  getBUTypeFromLocalStorage,
  getFeaturesListFromLocalStorage,
} from "helpers/storage";

const token = getTokenFromLocalStorage();
const selectedBU = getBUFromLocalStorage();
const selectedBUType = getBUTypeFromLocalStorage();
const featuresList = getFeaturesListFromLocalStorage();
export const persistVersion = "4.0";

type FeatureList = (string | null | undefined)[] | null | undefined;

type AppContextStateValues = {
  featuresList: FeatureList;
  selectedBU: number;
  selectedBUType: string | null;
  token: string | null;
};

type AppContextState = {
  mainAppState: AppContextStateValues;
};

type AppContextHandlers = {
  setFeaturesList: (features: FeatureList) => void;
  changeMainAppState: React.Dispatch<React.SetStateAction<AppContextStateValues>>;
};

type AppContext = AppContextHandlers & AppContextState;

export const AppContext = React.createContext<AppContext>({} as AppContext);

interface IProps {
  children?: React.ReactNode;
}

const AppProvider: React.FC<IProps> = ({ children }) => {
  const [mainAppState, changeMainAppState] = useState<AppContextStateValues>({
    featuresList: featuresList?.split(","),
    selectedBU,
    selectedBUType,
    token,
  });

  const setFeaturesList = (features: FeatureList): void => {
    changeMainAppState((state) => ({
      ...state,
      featuresList: features,
    }));
  };

  const values = {
    mainAppState,
    changeMainAppState,
  };

  const updaters = {
    setFeaturesList,
  };

  return <AppContext.Provider value={{ ...values, ...updaters }}>{children}</AppContext.Provider>;
};

export default AppProvider;
